<template>
  <el-dialog style="max-height: 80%;top: 10%;" width="620px" :title="getRoomType==1?'查看房间详情':getRoomType==2?'查看床位详情':'查看台位详情'" :visible.sync="visible" :append-to-body="true" @close="$emit('update:show', false)">
    <div class="useDetails">
      <p class="useDetails_title">
        <span>订单号：{{ detailData.orderCode }}</span>
        <span>共使用人数：{{ detailDataArr.length }}人</span>
      </p>
      <ul v-for="(item,index) in detailDataArr" :key="index" class="useDetailsList_class">
        <p>
          <span class="circles"></span>
          <span>{{ item.customerName }}</span>
          <span v-if="item.customerPhone">{{ '/'+item.customerPhone }}</span>
        </p>
        <li v-for="(v,n) in item.logList" :key="n">
          <div class="liMiddle">
            <samp></samp>
          </div>
          <div v-if="item.logList.length != n+1" class="label"></div>
          <div class="liRight">
            <p>{{ v.logTime }} <span v-if="v.logType==1||v.logType==2||v.logType==3||v.logType==5||v.logType==9||v.logType==10" :class="v.logType==3?'circles-r':v.logType==5?'circles-l':'circles-g'">{{ v.logType==1?'锁':v.logType==2?'预':v.logType==3?'入':v.logType==5?'离':v.logType==9?'修':v.logType==10?'解':'' }}</span></p>
            <p v-if=" getRoomType==1">房间名称：{{ v.name }}</p>
            <p v-else>{{ getRoomType==2?'床位':'台位' }}：{{ v.name+'/'+v.bedNumber }}</p>
          </div>
        </li>
        <div v-if="detailDataArr.length == 0" class="noneDetailsData">
          <h4 class="i">!</h4>
          <h6>暂无数据</h6>
        </div>
      </ul>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Object,
      default: Object
    },
    detailDataArr: {
      type: Array,
      default: Array
    },
    getRoomType: {
      type: String,
      default: String,
    }
  },
  data() {
    return {
      visible: false, // 用来展示详情弹窗
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.visible = val;
      }
    }
  }
};

</script>

<style lang="less" scoped>
.useDetails {
    min-height: 300px;
    ul {
        list-style-type: none;
        .noneDetailsData {
            padding: 100px 0 0 0;
            .i {
                display: block;
                text-align: center;
                width: 22px;
                height: 22px;
                line-height: 22px;
                font-size: 17px;
                color: #cecece;
                border: 2px solid #cecece;
                margin: 0 auto;
                border-radius: 50%;
            }
            h6 {
                color: #999;
                font-size: 14px;
                text-align: center;
                height: 40px;
                line-height: 40px;
            }
        }
        li {
            display: flex;
            line-height: 20px;
            .liLeft {
                padding-top: 3px;
                width: 90px;
                font-size: 14px;
                line-height: 16px;
                color: #333;
            }
            .liMiddle {
                width: 31px;
                padding-top: 5px;
                position: relative;
                z-index: 1;
                span {
                    display: block;
                    width: 17px;
                    height: 17px;
                    border-radius: 50%;
                    background-color: #fff;
                    border: 1px solid #d8dce5;
                    position: relative;
                    margin-left: -1px;
                    margin-top: -3px;
                }
                samp {
                    display: block;
                    width: 14px;
                    height: 14px;
                    margin: 0 3px;
                    border-radius: 50%;
                    background-color: #d8dce5;
                }
            }
            .label {
                border-left: 1px solid #d8dce5;
                position: relative;
                top: 6px;
                left: -22px;
                z-index: 0;
            }
            .liRight {
                flex: 1;
                padding-bottom: 30px;
                p {
                    font-size: 14px;
                    color: #333;
                    min-height: 24px;
                    line-height: 24px;
                    span {
                        margin-left: 10px;
                        width: 20px;
                        height: 20px;
                        display: inline-block;
                        background: #D8DCE5FF;
                        color:#fff ;
                        border-radius: 50%;
                        text-align: center;
                        line-height: 20px;
                        font-size: 12px;
                    }
                }
                h5 {
                    font-size: 14px;
                    color: #333;
                    min-height: 24px;
                    line-height: 24px;
                    span {
                        padding-right: 20px;
                    }
                }
            }
        }
    }
}
.useDetailsList_class > p  .circles{
  display: inline-block;
  width: 14px;
  height: 14px;
  background: #E4E7ED;
  border-radius: 50%;
  margin-right: 15px;
  vertical-align: middle;
  }
.useDetailsList_class li {
 margin-left:15px;
}
.circles-r{
  background: #FFF7E5!important;
  color: #FFBF39!important;
}
.circles-g{
  background: #F0F5FF!important;
  color: #83A7EB!important;
}
.circles-l{
  background: #FFF0ED!important;
  color: #F87E61!important;
}
</style>
<style scoped>
.useDetailsList_class + .useDetailsList_class {
    border-top: 1px solid #e6ebf5;
    padding-top: 19px;
}
.useDetails_title {
    background: rgba(245, 247, 250, 1);
    padding: 16px 21px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}
.useDetailsList_class > p {
    margin-bottom: 20px;
    height: 20px

}

</style>
